<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Yakınlık Derece</label>
            <v-validator :errors="errors" parameter="EmployeeRelationDegreeId" :watch="degree">
                <v-select-list v-model="degree" placeholder="Yakınlık Derece" label="Name" :options="degrees"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ad</label>
            <v-validator :errors="errors" parameter="FirstName" :watch="value.FirstName">
                <input type="text" class="form-control" v-model="value.FirstName" placeholder="Ad"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Soyad</label>
            <v-validator :errors="errors" parameter="LastName" :watch="value.LastName">
                <input type="text" class="form-control" v-model="value.LastName" placeholder="Soyad"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Telefon</label>
            <v-validator :errors="errors" parameter="PhoneNumber" :watch="value.PhoneNumber">
                <input type="text" class="form-control" v-model="value.PhoneNumber" placeholder="Telefon"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            degrees:[]
        }
    },
    mounted(){
        this.getRelationDegrees()
    },
    methods:{
        getRelationDegrees(){
            SystemDataApi.RelationDegree().then(res=>{
                this.degrees = res.data.Data
            })
        }
    },
    computed:{
        degree:{
            get:function(){
                return this.degrees.find(b=>b.Id==this.value.EmployeeRelationDegreeId)
            },
            set:function(value){
                this.value.EmployeeRelationDegreeId = value?.Id || null
                this.value.EmployeeRelationDegreeName = value?.Name
            }
        }
    }
}
</script>

<style>

</style>